module.exports = __webpack_public_path__ + "static/media/VideoRecordori.2f319934.ogg";